// src/store/useChoicesFilterStore.ts
import { create } from "zustand";

interface Gender {
  id: number;
  value: string;
  is_aggregate: boolean;
}

interface MasterSchemeInterface {
  id: number;
  value: string;
}

interface ChoicesFilterState {
  openChoicesModal: boolean;
  startDate: string;
  endDate: string;
  schemeKeyword: string;
  stateId: number | null;
  categoryId: number | null;
  occupationId: number | null;
  educationId: number | null;
  incomeId: number | null;
  familyIncomeId: number | null;
  ageFrom: number | null;
  ageTo: number | null;
  selectedGender: string;
  currentTab: number;
  searchValue:string;
  applyFilter:boolean;

  // lists
  states: MasterSchemeInterface[];
  genderList: Gender[];
  occupation: MasterSchemeInterface[];
  education: MasterSchemeInterface[];
  income: MasterSchemeInterface[];

  // actions
  setOpenChoicesModal: (val: boolean) => void;
  setStartDate: (val: string) => void;
  setEndDate: (val: string) => void;
  setSchemeKeyword: (val: string) => void;
  setStateId: (val: number | null) => void;
  setCategoryId: (val: number | null) => void;
  setOccupationId: (val: number | null) => void;
  setEducationId: (val: number | null) => void;
  setIncomeId: (val: number | null) => void;
  setFamilyIncomeId: (val: number | null) => void;
  setAgeFrom: (val: number | null) => void;
  setAgeTo: (val: number | null) => void;
  setSelectedGender: (val: string) => void;
  setCurrentTab: (val: number) => void;
  setSearchValue: (val: string) => void;
  setApplyFilter: (val: boolean) => void;
  resetFilter: () => void;

  //list actions
  setStates:(val:any[])=>void,
  setGenderList:(val:any[])=>void,
  setOccupation:(val:any[])=>void
  setEducation:(val:any[])=>void
  setIncome:(val:any[])=>void
}

export const useSurveysResponseFilterStore = create<ChoicesFilterState>((set) => ({
  openChoicesModal: false,
  startDate: "",
  endDate: "",
  schemeKeyword: "",
  stateId: null,
  categoryId: null,
  occupationId: null,
  educationId: null,
  incomeId: null,
  familyIncomeId: null,
  ageFrom: null,
  ageTo: null,
  selectedGender: "",
  currentTab: 0,
  searchValue:'',
  applyFilter:true,

  // lists (can be loaded later via API)
  states: [],
  genderList: [],
  occupation: [],
  education: [],
  income: [],

  setOpenChoicesModal: (val) => set({ openChoicesModal: val }),
  setStartDate: (val) => set({ startDate: val }),
  setEndDate: (val) => set({ endDate: val }),
  setSchemeKeyword: (val) => set({ schemeKeyword: val }),
  setStateId: (val) => set({ stateId: val }),
  setCategoryId: (val) => set({ categoryId: val }),
  setOccupationId: (val) => set({ occupationId: val }),
  setEducationId: (val) => set({ educationId: val }),
  setIncomeId: (val) => set({ incomeId: val }),
  setFamilyIncomeId: (val) => set({ familyIncomeId: val }),
  setAgeFrom: (val) => set({ ageFrom: val }),
  setAgeTo: (val) => set({ ageTo: val }),
  setSelectedGender: (val) => set({ selectedGender: val }),
  setCurrentTab: (val) => set({ currentTab: val }),
  setSearchValue: (val:string) => set({ searchValue: val }),
  setApplyFilter: (val:boolean) => set({ applyFilter: val }),

  setStates: (val) => set({ states: val }),
  setEducation: (val) => set({ education: val }),
  setOccupation: (val) => set({ occupation: val }),
  setIncome: (val) => set({ income: val }),
  setGenderList: (val) => set({ genderList: val }),

  resetFilter: () =>
    set({
      startDate: "",
      endDate: "",
      schemeKeyword: "",
      stateId: null,
      categoryId: null,
      occupationId: null,
      educationId: null,
      incomeId: null,
      familyIncomeId: null,
      ageFrom: null,
      ageTo: null,
      selectedGender: "",
    }),
}));

export const useActiveResponseFilterCount = () =>
  useSurveysResponseFilterStore((state) => {
    const filters = [
      state.startDate,
      state.endDate,
      state.schemeKeyword,
      state.stateId,
      state.categoryId,
      state.occupationId,
      state.educationId,
      state.incomeId,
      state.familyIncomeId,
      state.ageFrom,
      state.ageTo,
      state.selectedGender,
      state.searchValue,
    ];
    return filters.filter((val) => val !== null && val !== "" && val !== undefined).length;
  });